import type { FunctionComponent } from "react";


import { Link } from "react-router-dom";
import type { ISocial } from "../../../types/models/social.models.types";
import { Button } from "../../ui/button";

type AppProps = {
	social: ISocial;
	className?: string;
};
export const RejectButton: FunctionComponent<AppProps> = ({
	social,
	className,
}) => {
	if (social.applicationStatus.status === "applied") {
		return (
			<Link to={`/admin/socials/${social.id}/reject`} className={className}>
				<Button
					className={`bg-rejectbuttonbg border border-rejectbuttonborder font-semibold text-rejectbuttontext tracking-wider w-full ${className}`}
				>
					Reject
				</Button>
			</Link>
		);
	}

	if (social.applicationStatus.status === "rejected") {
		return (
			<Button
				className={`bg-rejectbuttonbg border border-rejectbuttonborder font-semibold text-rejectbuttontext tracking-wider ${className}`}
			>
				Rejected
			</Button>
		);
	}

	if (social.applicationStatus.status === "approved") {
		return (
			<Link to={`/admin/socials/${social.id}/reject`} className={className}>
				<Button
					className={`bg-rejectbuttonbg border border-rejectbuttonborder font-semibold text-rejectbuttontext tracking-wider ${className}`}
				>
					Reject
				</Button>
			</Link>
		);
	}

	return null;
};
